import { render, staticRenderFns } from "./NotificationsPage.vue?vue&type=template&id=c94bdad2&"
import script from "./NotificationsPage.vue?vue&type=script&lang=js&"
export * from "./NotificationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports